const companies = [
  'AL HATHBOOR GENERAL TRADING',
  'FOOD & LIFE GENERAL TRADING LLC',
  'UNIPEX DAIRY PRODUCTS CO. LTD',
  'FINE HYGIENIC PAPER FZE',
  'ELECTA GULF',
  'TRANSWORLD AVIATION FZE',
  'FAROOK INTERNATIONAL STATIONERY',
  'JBC EXPRESS FREIGHT',
  'AL KHAYAT BUILDING MAINTENANCE EST.',
  'AHMED RAMADHAN JUMA EST.',
  'AL SADEK INDUSTRIAL AND TRADING',
  'AL HATHBOOR GROUP LLC',
];

const MIN_CHARS_TO_FIRE = 1;


export default {
  getCompanies(search) {
    if (search.length < MIN_CHARS_TO_FIRE) {
      return { data: [] };
    }
    let filtered;
    if (search && search !== '') {
      filtered = companies.filter(company => company.includes(search.toUpperCase()));
    } else {
      filtered = companies;
    }

    const mappedResponse = filtered.map(company => ({ EMPLOYER_NAME: company }));

    return { data: mappedResponse };
  },
};
